import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    void navigator.serviceWorker.register("/sw.js").then((registration) => {
      const announceUpdate = () => window.dispatchEvent(new CustomEvent("bullseye:update-ready", {
        detail: registration,
      }));
      if (registration.waiting) announceUpdate();
      registration.addEventListener("updatefound", () => {
        registration.installing?.addEventListener("statechange", () => {
          if (registration.waiting && navigator.serviceWorker.controller) announceUpdate();
        });
      });
    }).catch(() => undefined);
  });
}
